import { RootState } from '../index';

export const selectDealerById = (dealerId: string) => (state: RootState) => state.dealer.dealers[dealerId];
